import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Button from 'antd/lib/button'
import Card from 'antd/lib/card'
import Form from 'antd/lib/form'
import Input from 'antd/lib/input'
import Divider from 'antd/lib/divider'
import { Auth } from 'aws-amplify'
import guardianLoginBackground from '../assets/images/loginBackground.jpg'
import BSSLogo from '../components/Certificate/BSSLogo'
import { validatePassword } from '../components/Auth/helpers'
import { getQueryStringParams } from '../lib/QueryStringParams'
import ResetPassword from '../components/Auth/ResetPassword'
import ConfirmRegistraion from '../components/Auth/Registration/ConfirmRegistration'

import {
    setPasswordResetToken,
    setShowNewPassword,
    setShowResetPassword,
    setErrorMessage,
    setUser,
} from '../redux/auth/actions'
import NewPassword from '../components/Auth/NewPassword'
import Footer from '../components/Auth/Footer'

const { Item } = Form

const styles = {
    backgroundContainer: {
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        bottom: 0,
        height: '100%',
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0,
    },
    card: {
        background: 'rgba(255, 255, 255, 0.74)',
        borderRadius: '7px',
        padding: '0 2em',
    },
    formContainer: {
        position: 'absolute',
        left: '50%',
        margin: 'auto',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: 520,
    },
    logoContainer: {
        margin: '0 auto',
        textAlign: 'center',
        width: '68%',
    },
    signUpLink: {
        display: 'block',
        marginTop: '3em',
        textAlign: 'center',
    },
    submitButton: {
        width: '100%',
    },
    ssoButton: {
        width: '100%',
        marginBottom: 5,
        background: '#52c41a',
        borderColor: '#52c41a'
    },
    submitContainer: {
        textAlign: 'center',
    },
    welcome: {
        marginTop: '1em',
        textAlign: 'center',
    },
    signUpButton: {
        marginLeft: 5,
    },
    link: {
        color: '#1BAAF1',
        cursor: 'pointer',
    },
    linkRight: {
        color: '#1BAAF1',
        cursor: 'pointer',
        float: 'right',
    },
    error: {
        color: 'red',
        textAlign: 'center',
        fontSize: 14,
    },
}

const Login = ({ authState, onStateChange }) => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [showLathamSSO, setShowLathamSSO] = useState(false)

    const width = useSelector((state) => state.app.width)
    const showLogin = useSelector((state) => state.auth.showLogin)
    const showNewPassword = useSelector((state) => state.auth.showNewPassword)
    const showConfirmationForm = useSelector((state) => state.auth.showConfirmationForm)
    const showResetPassword = useSelector((state) => state.auth.showResetPassword)
    const errorMessage = useSelector((state) => state.auth.errorMessage)

    useEffect(() => {
        let search = window.location.search
        let pathname = window.location.pathname
        let paths = pathname.split('/')
        let searchParams = getQueryStringParams(search)
        if (searchParams['reset']) {
            setShowResetPassword(true)
            setPasswordResetToken(searchParams['reset'])
            setEmail(searchParams['email'])
        } else if (searchParams['confirm']) {
            showConfirmationForm(searchParams['confirm'], searchParams['code'], false)
        } else if ((paths[1] === 'invite' || paths[1] === 'registration') && paths[2]) {
            onStateChange('signUp', { token: paths[2] })
        } else if (paths[1] === 'login' && paths[2] === 'latham') {
            setShowLathamSSO(true)
        }
    }, [window])

    const login = () => {
        if (password.length > 0) {
            Auth.signIn(email.toLowerCase(), password.trim())
                .then((user) => {
                    if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                        setUser(user)
                        setErrorMessage('')
                        setUser(user)
                        setShowNewPassword(true)
                    } else {
                        onStateChange('signedIn', {})
                    }
                })
                .catch((err) => {
                    setErrorMessage(err.message)
                    if (err.code === 'PasswordResetRequiredException') {
                        setShowResetPassword(true)
                    }
                    if (err.code === 'UserNotConfirmedException') {
                        showConfirmationForm(email.toLowerCase(), null, true)
                    }
                })
        } else {
            setErrorMessage('Password cannot be empty')
        }
    }

    let containerStyle =
        width < 576 ? { ...styles.formContainer, width: '86%' } : styles.formContainer
    const bgImgUrl = guardianLoginBackground
    const backgroundContainerStyle = {
        ...styles.backgroundContainer,
        backgroundImage: `url(${bgImgUrl})`,
    }

    return (
        authState === 'signIn' && (
            <div style={backgroundContainerStyle}>
                <div style={containerStyle}>
                    <Card style={styles.card}>
                        <div style={styles.logoContainer}>
                            <svg
                                version="1.1"
                                viewBox="0 0 126.17 53.72"
                                width="100%"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <BSSLogo />
                            </svg>
                        </div>
                        {showLogin && (
                            <>
                                <h2 style={styles.welcome}>
                                    {showResetPassword ? 'Reset Your Password' : 'Welcome'}
                                </h2>
                                <div style={styles.error}>{errorMessage}</div>
                                {!showResetPassword && (
                                    <Form>
                                        <Item label="E-mail">
                                            <Input
                                                onChange={(e) => setEmail(e.target.value)}
                                                type="email"
                                                value={email}
                                            />
                                        </Item>
                                        <Item label="Password">
                                            <Input
                                                onChange={(e) => setPassword(e.target.value)}
                                                type="password"
                                                value={password}
                                            />
                                        </Item>
                                        <Item style={styles.submitContainer}>
                                            <Button
                                                htmlType="submit"
                                                onClick={login}
                                                size="large"
                                                style={styles.submitButton}
                                                type="primary"
                                            >
                                                SIGN IN
                                            </Button>
                                        </Item>

                                        {showLathamSSO && (
                                            <div>
                                                <Divider>Or</Divider>
                                                <Button
                                                    htmlType="submit"
                                                    href={process.env.REACT_APP_LATHAM_SSO_URL}
                                                    target='_blank'
                                                    size="large"
                                                    style={styles.ssoButton}
                                                    type="primary">
                                                    Single-Sign On
                                                </Button>
                                            </div>
                                        )}
                                    </Form>
                                )}

                                <Footer onStateChange={onStateChange} />
                            </>
                        )}
                        {showConfirmationForm && <ConfirmRegistraion />}
                        {showNewPassword && <NewPassword onStateChange={onStateChange} />}
                        {showResetPassword && <ResetPassword onStateChange={onStateChange} email={email} />}
                    </Card>
                </div>
            </div>
        )
    )
}

export default Login
